// extracted by mini-css-extract-plugin
export default {"formButtons":"SetUpProduct_formButtons__v1s0D","checkboxClassName":"SetUpProduct_checkboxClassName__TbXWJ","formButton":"SetUpProduct_formButton__1Jow2"};